/**
 * external_case_source stores canonical machine keys (CARTEGRAPH, CITY_WORKS, ...) alongside
 * arbitrary agency-named sources. Staff-facing copy humanizes the known partners and passes any
 * other name through verbatim, so a named partner always shows its real source. The partner
 * labels match the copy already used by InternalNoteTile.getNoteExternalSource.
 */
const EXTERNAL_SOURCE_DISPLAY_NAMES: { [name: string]: string } = {
  CARTEGRAPH: 'Cartegraph',
  CITY_WORKS: 'CityWorks',
  LUCITY: 'Lucity',
  CODE_CASE: 'Code Case',
};

export const getExternalSourceDisplayName = (name?: string | null): string => {
  if (!name) {
    return '';
  }

  // Own-property check so a name like 'toString' or 'constructor' resolves to itself rather than
  // an inherited Object.prototype member, preserving the pass-through contract for any source name.
  return Object.prototype.hasOwnProperty.call(EXTERNAL_SOURCE_DISPLAY_NAMES, name)
    ? EXTERNAL_SOURCE_DISPLAY_NAMES[name]
    : name;
};
